import { flow as lodashFlow } from 'lodash'
import { FlowFunction } from '../../types'

export function flow<T>(...flows: Array<FlowFunction<T>>): FlowFunction<T> {
  return lodashFlow(flows)
}
